import React from 'react';

import { observer } from 'mobx-react';

import classes from './NgzScanIqPaymentTab.module.scss';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { useCoachSeats } from '../../../hooks/useCoachSeats';
import { angularizeWithProviders } from '../../../../shared/providers';
import { ConnectStripeWidget } from '../../../containers/ConnectStripeWidget/ConnectStripeWidget';
import { CoachSeatsWidget } from '../../../containers/CoachSeatsWidget/CoachSeatsWidget';
import { ScanIqSubscriptionsManagement } from '../../../containers/EntitySubscriptionsManagement/ScanIqSubscriptionsManagement/ScanIqSubscriptionsManagement';
import { ScanIqTaxWidget } from '../../../containers/ScanIqTaxWidget/ScanIqTaxWidget';

type NgzScanIqPaymentTabProps = {
  entityId: number;
  isStripeConnected: boolean;
};

const NgzScanIqPaymentTab = observer(
  ({ entityId, isStripeConnected }: NgzScanIqPaymentTabProps) => {
    const { isSuperAdmin } = loggedInUserDataStore;

    const { coachSeats } = useCoachSeats(entityId);

    return (
      <>
        <div className={classes.row}>
          <ConnectStripeWidget
            entityId={entityId}
            isStripeConnected={isStripeConnected}
            disabled={isSuperAdmin}
          />
          <ScanIqTaxWidget entityId={entityId} />
        </div>
        <CoachSeatsWidget
          entityId={entityId}
          isCoachSeatsCreated={!!coachSeats}
          defaultMode="VIEW"
          coachSeats={coachSeats}
        />
        <ScanIqSubscriptionsManagement entityId={entityId} />
      </>
    );
  },
);

angularizeWithProviders(NgzScanIqPaymentTab, 'ngzScanIqPaymentTab', {
  entityId: '<',
  isStripeConnected: '<',
});
